import { Button, Callout, P } from '@ahmdigital/ui';
import { PRODUCT } from '@ahmdigital/constants';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import calculatePriceDifference from './utils/calculate-price-difference';
import calloutImage from './images/base.svg';
import getCustomerHasChanged from '../../../../utils/customer-has-changed';
import PriceActions from '../../../../actions/price';
import PriceService from '../../../../models/price';
import selectCustomer from '../../../../selectors/select-customer';
import selectEffectiveDateOverride from '../../../../selectors/select-effective-date-override';
import selectPrices from '../../../../selectors/select-prices';
import styles from './styles.module.sass';
import truncateFrequency from '../../../../utils/truncate-frequency';
import UrlService from '../../../../models/url';

const productIds = [PRODUCT.AMBULANCE_BASIC_EXCESS_750, PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_750];

const AmbulanceBasicUpgradeCallout = () => {
  const customer = useSelector(selectCustomer);
  const prices = useSelector(selectPrices);
  const effectiveDate = useSelector(selectEffectiveDateOverride);
  const dispatch = useDispatch();
  const customerHasChanged = getCustomerHasChanged(customer);

  useEffect(() => {
    dispatch(PriceActions.load(productIds, customer, { date: effectiveDate }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerHasChanged, dispatch, effectiveDate]);

  const priceDifference = calculatePriceDifference(
    PriceService.getPrices(prices ?? {}, productIds, customer, { date: effectiveDate }),
    customer.frequency,
  );

  if (!priceDifference) {
    return null;
  }

  return (
    <Callout variant={['grey50Border', 'grey10', 'marginBottom', 'marginTopSpacer9']} imageSrc={calloutImage.src}>
      <div className={styles.calloutTextContainer}>
        <P variant="bold">
          Add cover for Accidents where we will pay benefits towards the initial and ongoing hospital treatment from an
          Accident for all services that are listed as excluded or restricted on your cover for just {priceDifference}{' '}
          per {truncateFrequency(customer.frequency)}.
        </P>

        <Button
          to={UrlService.getProductUrl(PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_750)}
          variant={['border', 'small', 'white']}
        >
          See product
        </Button>
      </div>
    </Callout>
  );
};

export default AmbulanceBasicUpgradeCallout;
